import * as React from "react";

const { Component } = React;

import { FormGroup, Input, Label } from "../components/Modal";

import { createOrSaveIntegration } from "./IntegrationStore";
import { alert } from "../general/alertStore.js";
import IntegrationTrigger from "./IntegrationTrigger";
import axios from "../general/HttpClient";
import { GetContext, UnsubscribeContext } from "../general/ApplicationContext";

class AzurePhotoIntegrationConfig {
    managedServiceID?: string;
    exportStaff: boolean;
    exportStudents: boolean;
    exportParents: boolean;
    exportGuests: boolean;

    constructor(config) {
        let _config = config || {};
        this.managedServiceID = _config.managedServiceID || "";
        this.exportStaff = _config.exportStaff === undefined || _config.exportStaff === null ? true : _config.exportStaff;
        this.exportStudents = _config.exportStudents === undefined || _config.exportStudents === null ? true : _config.exportStudents;
        this.exportParents = _config.exportParents === undefined || _config.exportParents === null ? false : _config.exportParents;
        this.exportGuests = _config.exportGuests === undefined || _config.exportGuests === null ? false : _config.exportGuests;
    }
}

class AzurePhotoIntegration {
    config: AzurePhotoIntegrationConfig;
    name: string;
    integrationDirection: number;
    integrationType: number;
    integrationId: number;
    triggerId: string;
    triggerLastRun: string;
    triggerEnabled: boolean;
    organizationId: string;

    constructor(integration: any = {}) {
        this.name = integration.name || "";
        this.integrationDirection = integration.integrationDirection;
        this.integrationType = integration.integrationType;
        this.integrationId = integration.integrationId;
        this.triggerId = integration.triggerId;
        this.triggerLastRun = integration.triggerLastRun;
        this.triggerEnabled = integration.triggerEnabled;
        this.organizationId = integration.organizationId;

        this.config = new AzurePhotoIntegrationConfig(integration.config);
    }
}

interface AzurePhotoState {
    profiles: Array<AzurePhotoIntegration>;
    users: any;
    selectedProfile: AzurePhotoIntegration;
    selectedProfileId: string;
    syncResult: any;

    managedServices: Array<any>;
}

interface AzurePhotoProps {
    organization: string;
}

let contextSubscriptionId = "";

export default class ExportAzurePhotos extends Component<AzurePhotoProps, AzurePhotoState> {
    constructor(props) {
        super(props);

        this.state = {
            profiles: [],
            users: [],
            selectedProfile: new AzurePhotoIntegration(),
            selectedProfileId: "",
            syncResult: undefined,
            managedServices: [],
        };
    }

    saveProfile = () => {
        if (this.state.selectedProfile.name) {
            this.setState(
                (prevState) => {
                    prevState.selectedProfile.integrationDirection = 1; //Out
                    prevState.selectedProfile.integrationType = 9; //AzurePhoto
                    prevState.selectedProfile.organizationId = this.props.organization;

                    return prevState;
                },
                () => {
                    createOrSaveIntegration(this.state.selectedProfile).then(() => {
                        this.getProfiles();
                    });
                }
            );
        }
    };

    syncUsers = () => {
        axios.post(`/api/Integrations/${this.state.selectedProfileId}/ExportPhotosToAzure`, this.state.selectedProfile.config).then(
            (response) => {
                alert({
                    type: response.data.success ? "alert-success" : "alert-danger",
                    text: response.data.success ? `Photos synced successfully` : response.data.errors.join("\n"),
                });
            },
            (response) => {
                this.setState({ syncResult: response.data });
            }
        );
    };

    componentDidMount() {
        contextSubscriptionId = GetContext((context) => {
            this.getProfiles();
        });
    }

    componentWillUnmount() {
        UnsubscribeContext(contextSubscriptionId);
    }

    getProfiles = () => {
        axios
            .get(`/api/Integrations/Types/9`) //AzurePhoto
            .then((response) => {
                this.setState({ profiles: response.data, selectedProfile: new AzurePhotoIntegration(), selectedProfileId: "" });
            });

        axios
            .get(`/api/ManagedServices/ListManagedServices/${this.props.organization}/5`) //AzurePhoto
            .then((response) => {
                this.setState({ managedServices: response.data });
            });
    };

    handleProfileChange = (e) => {
        let id = e.target.value;
        this.setState((prevState) => ({
            selectedProfileId: id,
            selectedProfile: new AzurePhotoIntegration(prevState.profiles.filter((profile) => profile.integrationId == id)[0]),
        }));
    };

    handleNameChange = (e) => {
        let name = e.target.value;
        this.setState((prevState) => {
            prevState.selectedProfile.name = name;
            return prevState;
        });
    };

    handleManagedServiceChange = (e) => {
        let managedService = e.target.value;
        this.setState((prevState) => {
            prevState.selectedProfile.config.managedServiceID = managedService;
            return prevState;
        });
    };

    handleExportStaffChange = (e) => {
        let checked = e.target.checked;
        this.setState((prevState) => {
            prevState.selectedProfile.config.exportStaff = checked;
            return prevState;
        });
    };

    handleExportStudentsChange = (e) => {
        let checked = e.target.checked;
        this.setState((prevState) => {
            prevState.selectedProfile.config.exportStudents = checked;
            return prevState;
        });
    };

    handleExportParentsChange = (e) => {
        let checked = e.target.checked;
        this.setState((prevState) => {
            prevState.selectedProfile.config.exportParents = checked;
            return prevState;
        });
    };

    handleExportGuestsChange = (e) => {
        let checked = e.target.checked;
        this.setState((prevState) => {
            prevState.selectedProfile.config.exportGuests = checked;
            return prevState;
        });
    };

    render() {
        return (
            <div>
                <h3 className="text-2xl font-bold text-gray-900 mb-6">Azure Photos</h3>

                <div className="space-y-6">
                    <div>
                        <FormGroup>
                            <Label htmlFor="profile">Profile</Label>
                            <Input type="select" id="profile" onChange={this.handleProfileChange} value={this.state.selectedProfileId}>
                                <option>Please Select</option>
                                {this.state.profiles.map((profile) => (
                                    <option key={profile.integrationId} value={profile.integrationId}>
                                        {profile.name}
                                    </option>
                                ))}
                            </Input>
                        </FormGroup>
                    </div>
                    
                    {this.state.selectedProfileId && (
                        <div>
                            <IntegrationTrigger integration={this.state.selectedProfile}></IntegrationTrigger>
                        </div>
                    )}
                    
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                        <FormGroup>
                            <Label htmlFor="profileName">Profile Name</Label>
                            <Input type="text" id="profileName" value={this.state.selectedProfile.name} onChange={this.handleNameChange} />
                        </FormGroup>
                        
                        {!this.state.selectedProfileId && (
                            <div className="flex items-end">
                                <button className="px-4 py-2 bg-green-600 text-white text-sm font-medium rounded-md hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-green-500 transition-colors" type="button" onClick={this.saveProfile}>
                                    Create Profile
                                </button>
                            </div>
                        )}
                    </div>
                    
                    {this.state.selectedProfileId && (
                        <div className="space-y-6">
                            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                                <FormGroup>
                                    <Label htmlFor="managedService">Managed Service</Label>
                                    <Input type="select" id="managedService" value={this.state.selectedProfile.config.managedServiceID} onChange={this.handleManagedServiceChange}>
                                        <option value="">Please Select</option>
                                        {this.state.managedServices.map((m) => (
                                            <option key={m.id} value={m.id}>
                                                Tenant: {m.configuration.tenantID}
                                            </option>
                                        ))}
                                    </Input>
                                </FormGroup>
                                
                                <FormGroup>
                                    <Label htmlFor="exportStaff" className="flex items-center">
                                        <Input
                                            type="checkbox"
                                            id="exportStaff"
                                            checked={this.state.selectedProfile.config.exportStaff}
                                            onChange={this.handleExportStaffChange}
                                            className="mr-2"
                                        />
                                        Export Staff
                                    </Label>
                                </FormGroup>
                                
                                <FormGroup>
                                    <Label htmlFor="exportStudents" className="flex items-center">
                                        <Input
                                            type="checkbox"
                                            id="exportStudents"
                                            checked={this.state.selectedProfile.config.exportStudents}
                                            onChange={this.handleExportStudentsChange}
                                            className="mr-2"
                                        />
                                        Export Students
                                    </Label>
                                </FormGroup>
                                
                                <FormGroup>
                                    <Label htmlFor="exportParents" className="flex items-center">
                                        <Input
                                            type="checkbox"
                                            id="exportParents"
                                            checked={this.state.selectedProfile.config.exportParents}
                                            onChange={this.handleExportParentsChange}
                                            className="mr-2"
                                        />
                                        Export Parents
                                    </Label>
                                </FormGroup>
                                
                                <FormGroup>
                                    <Label htmlFor="exportGuests" className="flex items-center">
                                        <Input
                                            type="checkbox"
                                            id="exportGuests"
                                            checked={this.state.selectedProfile.config.exportGuests}
                                            onChange={this.handleExportGuestsChange}
                                            className="mr-2"
                                        />
                                        Export Guests
                                    </Label>
                                </FormGroup>
                            </div>
                            
                            <div className="flex justify-end space-x-3">
                                <button className="px-4 py-2 bg-green-600 text-white text-sm font-medium rounded-md hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-green-500 transition-colors" type="button" onClick={this.saveProfile}>
                                    Save Profile
                                </button>
                                <button className="px-4 py-2 bg-blue-600 text-white text-sm font-medium rounded-md hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 transition-colors" type="button" onClick={this.syncUsers}>
                                    Sync
                                </button>
                            </div>

                            {this.state.syncResult && !this.state.syncResult.success && (
                                <div className="bg-red-50 border border-red-200 rounded-md p-4">
                                    <p className="text-red-800 font-medium">Errors occurred during sync</p>
                                </div>
                            )}
                        </div>
                    )}
                </div>
            </div>
        );
    }
}
